import { PlaceholderPipe } from "./placeholder-pipe.model";

export class Placeholder {

    private name: string;
    private value: any;
    private bold: boolean | undefined;
    private pipe: PlaceholderPipe | undefined;

    constructor(
        name: string,
        value: any,
        bold?: boolean,
        pipe?: PlaceholderPipe | undefined
    ) {
        this.name = name;
        this.value = value;
        this.bold = bold;
        this.pipe = pipe;
    }

    public static create(name: string, value: any, bold?: boolean, pipe?: PlaceholderPipe): Placeholder {
        return new Placeholder(name, value, bold, pipe);
    }

    public getName(): string {
        return this.name;
    }

    public setName(name: string): void {
        this.name = name;
    }

    public getValue(): any {
        return this.value;
    }

    public setValue(value: any): void {
        this.value = value;
    }

    public getBold(): boolean | undefined {
        return this.bold;
    }

    public setBold(bold: boolean | undefined): void {
        this.bold = bold;
    }

    public getPipe(): PlaceholderPipe | undefined {
        return this.pipe;
    }

    public setPipe(pipe: PlaceholderPipe | undefined): void {
        this.pipe = pipe
    }

}